/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TemplateInfoV1Dto = {
  /**
   * The first name of the signer
   */
  first_name: string;
  /**
   * The last name of the signer
   */
  last_name: string;
  /**
   * The email of the signer
   */
  email: string;
  /**
   * The phone number of the signer
   */
  phone_number?: string;
  /**
   * The locale of the signer
   */
  locale: TemplateInfoV1Dto.locale;
};
export namespace TemplateInfoV1Dto {
  /**
   * The locale of the signer
   */
  export enum locale {
    DE = 'de',
    EN = 'en',
    ES = 'es',
    FR = 'fr',
    IT = 'it',
    PT = 'pt',
  }
}
